import React from 'react';
import '../styles/loader.scss'

const Loader = () => {
    return (
        <div className="container__loader">
            <div className="loader"></div>
        </div>
    )
}

export default Loader;